import axios from "axios";
import moment from "moment";
import groups from "../../models/gestionTiempos/groups/groups";
import groupsAssigned from "../../models/gestionTiempos/groups/groupsAssigned";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getGroups = (date) => {
    let token = localStorage.getItem("token");
    let operId = localStorage.getItem("operId");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let fecha = date === null ? moment().format("YYYY-MM-DD") : date;
    return axios
      .get(`${url}/grupos/${operId}&${fecha}`, { headers })
      .then(({ data }) =>
        data.map((item) => {
          return groups.fromJson(item);
        })
      );
  };

  new = (data) => {
    let token = localStorage.getItem("token");
    let empId = parseInt(localStorage.getItem("empId"), 10);
    let operId = parseInt(localStorage.getItem("operId"), 10);
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let payload;

    payload = {
      empId: empId,
      fecha:
        data.date == null
          ? moment().format("YYYY-MM-DD") + "T00:00:00.000Z"
          : data.date + "T00:00:00.000Z",
      desde: data.from + "T00:00:00.000Z",
      hasta: data.to
        ? moment(data.to).format("YYYY-MM-DD") + "T00:00:00.000Z"
        : undefined,
      operId: operId,
      grupoId: data.group,
      defaultGrp: data.defaultGrp,
    };

    return axios.post(`${url}/empgrupos`, payload, { headers });
  };
  getGroupsAssigned = () => {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    const empId = localStorage.getItem("empId");
    return axios
      .get(`${url}/empgrupos/${empId}`, { headers })
      .then(({ data }) =>
        data.map((item) => {
          return groupsAssigned.fromJson(item);
        })
      );
  };

  delete = (data) => {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    const empId = localStorage.getItem("empId");
    const grupoid = data.id;
    const fecdesde = data.from;

    return axios.delete(`${url}/empgrupos/${empId}&${grupoid}&${fecdesde}`, {
      headers,
    });
  };
  edit = (data) => {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const empId = localStorage.getItem("empId");
    let grupoid = data.nameId;
    let desde = data.fromOld;
    let payload;
    payload = {
      fecha: moment().format("YYYY-MM-DD") + "T00:00:00.000Z",
      desde: data.from + "T00:00:00.000Z",
      haNoEx: data.haNoEx ? data.haNoEx : undefined,
      hasta:
        data.to && !data.haNoEx
          ? moment(data.to).format("YYYY-MM-DD") + "T00:00:00.000Z"
          : undefined,
      defaultGrp: data.defaultGrp,
    };

    return axios
      .patch(`${url}/empgrupos/${empId}&${grupoid}&${desde}`, payload, {
        headers,
      })
      .then(() => {});
  };
}
export default service;
